import type { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { logoLegacyDefaultV0Schema } from './default';

export type LegacyLogo = z.infer<typeof logoLegacyDefaultV0Schema>;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet).
 * Single shape, like line/indent/accordion — no envelope union.
 */
export const LegacyLogoEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: logoLegacyDefaultV0Schema }]);
